module.exports = __webpack_public_path__ + "static/media/as5cr93.d346bca3.png";